// extracted by mini-css-extract-plugin
module.exports = {"container":"SterilizersTable_container__3cwts","tableContainer":"SterilizersTable_tableContainer__Bc9ej"};